import { useMutation } from "@tanstack/react-query";
import { enableDisableJob } from "app/api/job_api";

const useEnableDisableJob = ({ onSuccess, onError }) => {
  return useMutation({
    mutationFn: async ({ jobId, status, updatedBy }) => enableDisableJob(jobId, status, updatedBy),
    onSuccess: onSuccess,
    onError: onError
  });
};

export default useEnableDisableJob;
